/* eslint-disable max-lines */
/* eslint-disable no-shadow */
import {
  call, takeEvery 
} from "redux-saga/effects";
import {
  injectApiWithContextFactory,
  injectBoundActionCreatorsFactory,
} from "Utils/sagaUtils";
import noop from "lodash.noop";
import { injectBoundGQLClient } from "Utils/injectBoundGQLClient";
import {
  LOAD_REQUESTED,
  UPDATE_DEFAULT_REQUESTED,
  UPDATE_REQUESTED,
  loadFailed,
  loadSucceeded,
  updateDefaultFailed,
  updateDefaultSucceeded,
  updateFailed,
  updateSucceeded,
} from "./projectConfig.duck";
import { loadProjectConfig, updateInstanceDefaultProjectConfig, updateProjectConfig } from "./projectConfig.api";

export const withBoundActions = injectBoundActionCreatorsFactory(
  {
    loadFailed,
    loadSucceeded,
    updateDefaultFailed,
    updateDefaultSucceeded,
    updateFailed,
    updateSucceeded,
  },
  () => "v3.project.config"
);

export const withApiContext = injectApiWithContextFactory(
  {
    loadProjectConfig,
    updateProjectConfig,
    updateInstanceDefaultProjectConfig,
  },
  injectBoundGQLClient
);

function* loadProjectConfigSaga({
  api: { loadProjectConfig },
  actions: { loadFailed, loadSucceeded },
  resolve = noop,
  reject = noop,
}) {
  try {
    const resp = yield loadProjectConfig();
    yield loadSucceeded(resp);
    yield call(resolve);
  } catch (error) {
    yield loadFailed(error);
    yield call(reject, error);
  }
}

function* updateProjectConfigSaga({
  data: { config },
  api: { updateProjectConfig },
  actions: { updateFailed, updateSucceeded },
  resolve = noop,
  reject = noop,
}) {
  try {
    const isOk = yield updateProjectConfig({ config });
    yield updateSucceeded(isOk);
    yield call(resolve);
  } catch (error) {
    yield updateFailed(false);
    yield call(reject, error);
  }
}

function* updateDefaultProjectConfigSaga({
  data: { config },
  api: { updateInstanceDefaultProjectConfig },
  actions: { updateDefaultFailed, updateDefaultSucceeded },
  resolve = noop,
  reject = noop,
}) {
  try {
    const isOk = yield updateInstanceDefaultProjectConfig({ config });
    yield updateDefaultSucceeded(isOk);
    yield call(resolve);
  } catch (error) {
    yield updateDefaultFailed(false);
    yield call(reject, error);
  }
}

export default () =>
  function* rootSaga() {
    yield takeEvery(LOAD_REQUESTED, withApiContext(withBoundActions(loadProjectConfigSaga)));
    yield takeEvery(UPDATE_REQUESTED, withApiContext(withBoundActions(updateProjectConfigSaga)));
    yield takeEvery(UPDATE_DEFAULT_REQUESTED, withApiContext(withBoundActions(updateDefaultProjectConfigSaga)));
  };
